export default "/images/79469e5e49c2f3b756f4e99ecd1494d3.avif";